
    import Component from "vue-class-component";
    import Vue from "vue";
    import {Prop} from "vue-property-decorator";
    import {
        ApplicationActions,
        ApplicationViewModel,
        Certificate,
        CertificateRequirementViewModel, CertificateStatus,
        IdentityValueViewModel,
        RequirementFulfillmentViewModel,
        RequirementsClient, ValidityStatus
    } from "@/api-client";
    import {BvTableFieldArray} from "bootstrap-vue"
    import TableItem from "@/features/applications/components/TableItem";
    import RequirementsTable from "@/features/applications/components/RequirementsTable.vue";
    import Loader from "@/features/shared/components/Loader";
    import {ls} from "@/CultureService";
    import {formatDate} from "@/formatting/dateFormatter";
    import CertificateStatusBadge from "@/features/shared/components/CertificateStatusBadge.vue";

    class CertificateTableItem implements TableItem {
        id: string;
        name: string;
        issuedAt: Date
        validUntil: Date | null | undefined; // TODO(KK): Get rid of undefined!
        status: CertificateStatus;

        constructor(certificate : Certificate) {
            this.id = certificate.id
            this.name = certificate.name
            this.issuedAt = certificate.issuedAt
            this.validUntil = certificate.validUntil
            this.status = certificate.status;
        }
    }

    @Component({
        components: {
            RequirementsTable,
            CertificateStatusBadge
        }
    })
    export default class CertificateRequirement extends Vue {
        public static requirementDescriptionTitle = ls.Applications_Requirements_Certificate_Title_CertificateRequirements;
        public static headingDescription = ls.Applications_Requirements_Certificate_Heading_AddingCertificate;

        @Prop({required: true})
        application!: ApplicationViewModel; // TODO: Constrain this.
        @Prop({required: true})
        requirementFulfillment!: RequirementFulfillmentViewModel;
        @Prop({required: true})
        requirement!: CertificateRequirementViewModel;
        @Prop({required: true})
        requirementValue!: IdentityValueViewModel | null;
        @Prop({required: true})
        actions!: ApplicationActions;

        chosenCertificate: Certificate[] | null = null;
        choosableCertificates: Certificate[] = [];

        chosenLoader = new Loader();
        choosableLoader = new Loader();

        fields: BvTableFieldArray = [
            {
                key: 'name',
                label: this.$ls.Global_Label_Certificate,
                sortable: false,
                thClass: "w-35"
            },
            {
                key: 'issuedAt',
                label: this.$ls.Global_Label_IssueDateShort,
                sortable: false,
                thClass: "w-15",
                formatter: (dateString : string) => formatDate(dateString)
            },
            {
                key: 'validUntil',
                label: this.$ls.Global_Label_ValidUntil,
                sortable: false,
                thClass: "w-10",
                formatter: (dateString : string) => formatDate(dateString)
            },
            {
                key: 'status',
                label: this.$ls.Global_Label_DocumentState,
                sortable: false,
                thClass: 'w-10'
            },
            {
                key: 'actions',
                label: '',
                sortable: false,
                tdClass: 'table-actions'
            }
        ];

        created() {
            if (this.requirementValue) {
                new RequirementsClient()
                    .setLoader(this.chosenLoader)
                    .chosenCertificate(this.application.id, this.requirement.id)
                    .then(result => this.chosenCertificate = result);
            }

            if (this.actions.canFillRequirements) {
                new RequirementsClient()
                    .setLoader(this.choosableLoader)
                    .choosable(this.application.id, this.requirement.id)
                    .then(result => this.choosableCertificates = result);
            }
        }

        async choose(tableItem: TableItem) {
            await new RequirementsClient().chooseCertificate(tableItem.id, this.application.id, this.requirement.id).then(
                () => this.$emit("application-changed"),
                error => this.$emit("error-happened", error));
        }

        async removeChosen(id: string) {
            await new RequirementsClient().removeChosenCertificate(id, this.application.id, this.requirement.id).then(
                () => this.$emit("application-changed"),
                error => this.$emit("error-happened", error));
        }

        get chosenTableItems() : TableItem[] {
          if (!this.chosenCertificate)
            return [];
          return this.chosenCertificate.map(x => new CertificateTableItem(x));
        }

        get choosableTableItems(): CertificateTableItem[] | null {
            if (!this.choosableCertificates) {
                return null;
            }
            return this.choosableCertificates.map(x => new CertificateTableItem(x))
        }

        viewDetails(certificate: CertificateTableItem){
            this.$router.push({name: "requirement-certificate-details", params:{certificateId: certificate.id}});
        }
    }
